function Content() {
  return (
    <div className="content">
      <div className="container">
        <h1 className="content-heading">Impressum</h1>
        <div class="rich-text-block w-richtext">
          <h3>Kontakt</h3>
          <p>
            Stefan Feldner <br/>
            Telefon: <a href="tel:+436701904065">+43 670 1904065</a>
            <br />
            E-Mail: <a href="mailto:info@wepanion.com">info@wepanion.com</a>
          </p>
          <strong>Hinweis</strong>
          <p>Diese Website dient ausschließlich privaten Zwecken als Portfolio zur Präsentation meiner bisherigen Arbeiten für potenzielle Arbeitgeber. Es werden keine Dienstleistungen angeboten. 
          </p>
          <h3>Urheberrechtshinweis</h3>
          <p>
            Alle Inhalte dieser Webseite (Bilder, Fotos, Texte, Videos)
            unterliegen dem Urheberrecht. Falls notwendig, werden wir die
            unerlaubte Nutzung von Teilen der Inhalte unserer Seite rechtlich
            verfolgen.
          </p>
          <h3>Haftung für Links auf dieser Webseite</h3>
          <p>
            Unsere Webseite enthält Links zu anderen Webseiten für deren Inhalt
            wir nicht verantwortlich sind. Wenn Ihnen rechtswidrige Links auf
            unserer Webseite auffallen, bitte wir Sie uns zu kontaktieren, Sie
            finden die Kontaktdaten im Impressum.
          </p>
          <h3>Datenschutz</h3>
          <p>
            Alle Informationen bezüglich dem Datenschutz finden Sie{' '}
            <a href="/data-policy">hier</a>.
          </p>
        </div>
      </div>
    </div>
  );
}

export default Content;
